type AdProps = {
  lazyRender?: boolean
  sticky?: boolean
}
export type AdPlacement = {
  outbrain: OutbrainProps
  taboola: TaboolaProps
  assertive: AssertiveProps
  style: Record<string, string | number> | undefined
  props: AdProps
}

export const placementConfigs: Record<string, AdPlacement> = {}
